import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-09fa5784")

_pushScopeId("data-v-09fa5784")
const _hoisted_1 = { class: "CancelInvoice" }
const _hoisted_2 = { class: "CancelInvoice__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "header__title" }, " Вы уверены что хотите отменить накладную? ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "CancelInvoice__warning" }, " При отмене накладной, все данные накладной будут утеряны. Вы желаете продолжить? ", -1)
const _hoisted_5 = { class: "CancelInvoice__actions" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Нет, вернуться назад")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Да, отменить накладную ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_icon_close, {
        class: "header__close",
        onClick: _ctx.emitClose
      }, null, 8, ["onClick"])
    ]),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_s_button, {
        class: "transparent",
        onClick: _ctx.emitClose
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_s_button, {
        loading: _ctx.loading,
        class: "black",
        onClick: _ctx.emitConfirm
      }, {
        default: _withId(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
})